module.exports = {"540328100":"嘎托镇","540328101":"如美镇","540328200":"索多西乡","540328201":"莽岭乡","540328202":"宗西乡","540328203":"昂多乡","540328204":"措瓦乡","540328205":"洛尼乡","540328206":"戈波乡","540328207":"帮达乡","540328208":"徐中乡","540328209":"曲登乡","540328210":"木许乡","540328211":"纳西民族乡","540328212":"竹巴龙乡","540328213":"曲孜卡乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540328.json
// module id = 2713
// module chunks = 0